import { render, staticRenderFns } from "./bookmarks.vue?vue&type=template&id=4518414d&scoped=true"
import script from "./bookmarks.vue?vue&type=script&lang=ts"
export * from "./bookmarks.vue?vue&type=script&lang=ts"
import style0 from "./bookmarks.vue?vue&type=style&index=0&id=4518414d&prod&lang=scss&scoped=true"
import style1 from "./bookmarks.vue?vue&type=style&index=1&id=4518414d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4518414d",
  null
  
)

export default component.exports